__turbopack_context__.v({
  "arrows": "zh1bGG_arrows",
  "flexSpace": "zh1bGG_flexSpace",
  "jobActions": "zh1bGG_jobActions",
  "jobBanner": "zh1bGG_jobBanner",
  "jobCardJobFields": "zh1bGG_jobCardJobFields",
  "jobCardTitle": "zh1bGG_jobCardTitle",
  "jobCardTitleWrapper": "zh1bGG_jobCardTitleWrapper",
  "jobDetailDescription": "zh1bGG_jobDetailDescription",
  "jobDetailInfo": "zh1bGG_jobDetailInfo",
  "jobDetailInfoHasBanner": "zh1bGG_jobDetailInfoHasBanner",
  "jobDetailInfoVerticalLayoutTablet": "zh1bGG_jobDetailInfoVerticalLayoutTablet",
  "jobDetailWrapper": "zh1bGG_jobDetailWrapper",
  "jobDetailWrapperFullContainer": "zh1bGG_jobDetailWrapperFullContainer",
  "jobDetailWrapperIsIframe": "zh1bGG_jobDetailWrapperIsIframe",
  "jobDetailWrapperOverflow": "zh1bGG_jobDetailWrapperOverflow",
  "jobDetailWrapperWithBottomMenu": "zh1bGG_jobDetailWrapperWithBottomMenu",
  "jobEditWrapper": "zh1bGG_jobEditWrapper",
  "jobFieldSeparator": "zh1bGG_jobFieldSeparator",
  "jobIcon": "zh1bGG_jobIcon",
  "jobInfo": "zh1bGG_jobInfo",
  "jobInfoItem": "zh1bGG_jobInfoItem",
  "jobLabelDescription": "zh1bGG_jobLabelDescription",
  "jobLogo": "zh1bGG_jobLogo",
  "jobMainInfoWrapper": "zh1bGG_jobMainInfoWrapper",
  "jobPictureWrapper": "zh1bGG_jobPictureWrapper",
  "jobShrinkedCardCompanyName": "zh1bGG_jobShrinkedCardCompanyName",
  "jobShrinkedCardTitle": "zh1bGG_jobShrinkedCardTitle",
  "jobShrinkedHeader": "zh1bGG_jobShrinkedHeader",
  "jobShrinkedHeaderActions": "zh1bGG_jobShrinkedHeaderActions",
  "shrinkedCardActionsCell": "zh1bGG_shrinkedCardActionsCell",
});
